import { render, staticRenderFns } from "./ReservationPeriod.vue?vue&type=template&id=13d3cf53&scoped=true&"
import script from "./ReservationPeriod.vue?vue&type=script&lang=js&"
export * from "./ReservationPeriod.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPeriod.vue?vue&type=style&index=0&id=13d3cf53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3cf53",
  null
  
)

export default component.exports